"use client"

import { HouseHeart } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `HouseHeartIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const HouseHeartIcon = component(Icon)({ as: HouseHeart })
